export function addParams(url, params) {
  // check if it already has params, and then add ?, if not, add &
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${params}`
}
